import {
  ageGroup,
  ComplaintById,
  ComplaintDisabledInfo,
  disabledInfoList,
  SituationTranslations,
} from "@modules/plaintes/plaintes.model.ts";
import React from "react";
interface VictimInfoProps {
  complaint: ComplaintById;
}
export const AgeFormat = (age: string) => {
    const ageFilter = ageGroup.filter((a) => a.code === age);
    return  ageFilter[0].name;
};
const VictimInfo: React.FC<VictimInfoProps> = ({ complaint }) => {
  const [handicapInfo, setHandicapInfo] = React.useState<{ name: string; code: ComplaintDisabledInfo } | undefined>();

  React.useEffect(() => {
    if (complaint.complaintDetails.length > 0) {
      const disabilityInfo = complaint.complaintDetails[0]?.disabilityInfo;
  
      if (disabilityInfo && Object.values(ComplaintDisabledInfo).includes(disabilityInfo)) {
        const info = disabledInfoList.find(i => i.code === disabilityInfo);
        setHandicapInfo(info);
      } else {
        setHandicapInfo(undefined);
      }
    } else {
      setHandicapInfo(undefined);
    }
  }, [complaint]);

  const textStudentOrEmploye = (situation: string | null) => {
    let text = "";

    if (situation === "YES") {
      text = "Oui";
    } else if (situation === "NO") {
      text = "Non";
    } else if (situation === "UNKNOWN") {
      text = "Aucune information";
    }

    return text;
  };

  return (
    <div className="rounded-[10px] p-4 bg-white flex flex-col">
      <span className="text-black text-sm font-semibold mb-2">
        Information sur la victime :
      </span>
      {complaint.complaintDetails.map((victim) => (
        <div className="w-full flex lg:flex-row flex-col items-baseline" key={victim.id}>
          <div className="gap-2 w-full lg:w-1/2 flex flex-col">
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Nom : &nbsp;
              </span>
              <span className="text-black text-sm">{`${victim.lastName} ${victim.firstName}`}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Sexe : &nbsp;
              </span>
              <span className="text-black text-sm">
                {victim.gender === "FEMALE" ? "Féminin" : "Masculin"}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Handicap : &nbsp;
              </span>
              <span className="text- text-sm text-black">
                {victim.disability ? "Oui" : "Non"}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Etudiant(e) : &nbsp;
              </span>
              <span className="text-black text-sm">{textStudentOrEmploye(victim.student)}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Père : &nbsp;
              </span>
              <span className="text-black text-sm">{victim.fatherName}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Situation matrimoniale : &nbsp;
              </span>
              <span className="text-black text-sm">
                {SituationTranslations[victim.martialStatus]}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Numéro de téléphone : &nbsp;
              </span>
              <span className="text-black text-sm">{victim.contactNumber}</span>
            </div>
          </div>
          <div className="gap-2 w-full lg:w-1/2 flex flex-col">
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Age : &nbsp;
              </span>
              <span className="text-black text-sm">
                {victim.ageGroup !== null ? AgeFormat(victim.ageGroup) : ""}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Remarque : &nbsp;
              </span>
              <span className="text-black text-sm">{handicapInfo?.name}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Employé(e) : &nbsp;
              </span>
              <span className="text-black text-sm">{textStudentOrEmploye(victim.employee)}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Mère : &nbsp;
              </span>
              <span className="text-black text-sm">{victim.motherName}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Vivre avec ses parents : &nbsp;
              </span>
              <span className="text-black text-sm">
                {victim.parentCohabitation ? "Oui" : "Non"}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Adresse : &nbsp;
              </span>
              <span className="text-black text-sm">
                {victim.contactAddress}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VictimInfo;
